import { SubHeading } from '../common/subHeading';
import TableNew from '../common/tableNew';

const generateTopHoldings = (holdings: any) => {
  return [
    [{ value: 'Holdings' }, { value: 'Weightage' }],
    ...holdings.map((holding: any) => [
      { value: holding.name },
      { value: `${holding.weighting}%` },
    ]),
  ];
};

export const Holdings = ({ holdings, investClick }) => {
  return (
    <div className="lil-mt-20">
      <SubHeading title="Top holdings" />
      <div>
        <TableNew
          data={generateTopHoldings(holdings.slice(0, 10) || [])}
          showInvestBtn={true}
          investClick={investClick}
        />
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./components/singleFundNewCmp/holdings.tsx